module.exports = __webpack_public_path__ + "static/media/cyber-services.aeb75ec4.png";